<div class="barcode-icon-container">
    <div class="barcode-icon">
        <img [src]="iconPath" [alt]="iconDescription" tooltipPosition="right" [pTooltip]="iconDescription">
        <sup class="billet-count" *ngIf="billetCount >= 2">{{ billetCount }}</sup>
    </div>
</div>
